import React from 'react'

import { IUserTypeContext, UserTypeContext } from './UserTypeContext'
import { UserTypeContextEnum } from './UserTypeContextEnum'

export function UserTypeContextProvider({
  userType,
  isAdmin = false,
  children,
}: {
  userType: UserTypeContextEnum
  children: React.ReactNode
  isAdmin?: boolean
}) {
  const context: IUserTypeContext = { userType, isAdmin }

  return (
    <UserTypeContext.Provider value={context}>
      {children}
    </UserTypeContext.Provider>
  )
}
